import React from 'react'

const Frontend = () => {
    return (
        <div className="skills__content">
            <h3 className="skills__title">Frontend Development</h3>

            <div className="skills__box">
                <div className="skills__group">
                    <div className="skills__data">
                        <div className="skills__header">
                            <i className='bx bx-badge-check'></i>
                            <h3 className="skills__name">HTML</h3>
                        </div>
                        <div className="skill__bar">
                            <div className="skill__bar-fill intermediate"></div>
                        </div>
                    </div>

                    <div className="skills__data">
                        <div className="skills__header">
                            <i className='bx bx-badge-check'></i>
                            <h3 className="skills__name">CSS</h3>
                        </div>
                        <div className="skill__bar">
                            <div className="skill__bar-fill intermediate"></div>
                        </div>
                    </div>

                    <div className="skills__data">
                        <div className="skills__header">
                            <i className='bx bx-badge-check'></i>
                            <h3 className="skills__name">Javascript</h3>
                        </div>
                        <div className="skill__bar">
                            <div className="skill__bar-fill intermediate"></div>
                        </div>
                    </div>
                </div>

                <div className="skills__group">
                    <div className="skills__data">
                        <div className="skills__header">
                            <i className='bx bx-badge-check'></i>
                            <h3 className="skills__name">React</h3>
                        </div>
                        <div className="skill__bar">
                            <div className="skill__bar-fill intermediate"></div>
                        </div>
                    </div>

                    <div className="skills__data">
                        <div className="skills__header">
                            <i className='bx bx-badge-check'></i>
                            <h3 className="skills__name">Bootstrap</h3>
                        </div>
                        <div className="skill__bar">
                            <div className="skill__bar-fill intermediate"></div>
                        </div>
                    </div>

                    <div className="skills__data">
                        <div className="skills__header">
                            <i className='bx bx-badge-check'></i>
                            <h3 className="skills__name">Tailwind CSS</h3>
                        </div>
                        <div className="skill__bar">
                            <div className="skill__bar-fill intermediate"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Frontend